import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Nav, Collapse } from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar'
import { isCompanySuspended } from '../suspension/suspension-banner';
import { COMPANY_SUSPENSION_EVENT } from '../../../utils/session';

const mapStateToProps = state => ({
	...state
});

class Sidebar extends React.Component {

	constructor(props) {
		super(props);
		this.expandLogo = this.expandLogo.bind(this);
		this.activeRoute.bind(this);
		this.state = {
			authentication: this.activeRoute("/authentication") !== "" ? true : false,
			uicomponents: this.activeRoute("/ui-components") !== "" ? true : false,
			samplepages: this.activeRoute("/sample-pages") !== "" ? true : false,
			dashboardpages: this.activeRoute("/dahboards") !== "" ? true : false,
			iconsPages: this.activeRoute("/icons") !== "" ? true : false,
			formlayoutPages: this.activeRoute("/form-layouts") !== "" ? true : false,
			formpickerPages: this.activeRoute("/form-pickers") !== "" ? true : false,
			admin_level: '',
			user: null,
			suspended: isCompanySuspended()
		};
		this.onSuspensionChange = this.onSuspensionChange.bind(this);
		this.blockWhileSuspended = this.blockWhileSuspended.bind(this);
	}
	// A suspended company's admin: every item but Account is greyed out and does nothing
	onSuspensionChange() {
		this.setState({ suspended: isCompanySuspended() });
	}
	blockWhileSuspended(event) {
		if (this.state.suspended && !(event.target.closest && event.target.closest('.allowed-while-suspended'))) {
			event.preventDefault();
			event.stopPropagation();
		}
	}
	componentWillUnmount() {
		window.removeEventListener(COMPANY_SUSPENSION_EVENT, this.onSuspensionChange);
	}
	componentDidMount() {
		window.addEventListener(COMPANY_SUSPENSION_EVENT, this.onSuspensionChange);
		let user = localStorage.getItem('mo_user');
		if(user!=null){
			let tmpUser = JSON.parse(user)
			this.setState({
				user:tmpUser,
				admin_level : localStorage.getItem('admin_level')
			})
		}else{
			this.setState({
				admin_level : localStorage.getItem('admin_level')
			})
		}
	}
	/*--------------------------------------------------------------------------------*/
	/*To Expand SITE_LOGO With Sidebar-Menu on Hover                                  */
	/*--------------------------------------------------------------------------------*/
	expandLogo() {
		document.getElementById("logobg").classList.toggle("expand-logo");
	}
	/*--------------------------------------------------------------------------------*/
	/*Verifies if routeName is the one active (in browser input)                      */
	/*--------------------------------------------------------------------------------*/
	activeRoute(routeName) { return this.props.location.pathname.indexOf(routeName) > -1 ? 'selected' : ''; }

	render() {
		let {admin_level} = this.state
		return (
			<aside className="left-sidebar" id="sidebarbg" data-sidebarbg={this.props.settings.activeSidebarBg} onMouseEnter={this.expandLogo} onMouseLeave={this.expandLogo}>
				<div className="scroll-sidebar">
					<PerfectScrollbar className="sidebar-nav">
						{/*--------------------------------------------------------------------------------*/}
						{/* Sidebar Menus will go here                                                */}
						{/*--------------------------------------------------------------------------------*/}
						<Nav id="sidebarnav" className={this.state.suspended ? 'sidebar-suspended' : ''} onClickCapture={this.blockWhileSuspended}>
							{this.props.routes.map((prop, key) => {
								if(prop.level!="c"){
									return null;
								}
								if (prop.redirect) {
									return null;
								}
								if (prop.name === "Account") {
									return null; // rendered separately below, company-admin only
								}
								if(admin_level!='a' && prop.name=="ReSellers"){
									return null;
								}
								if(admin_level!='a' && prop.superAdminOnly){
									return null;
								}
								if(admin_level!='b' && prop.resellerOnly){
									return null;
								}
								// A company admin or district manager: their company's dashboard and the company section below
								const companyLogin = admin_level === "c" || admin_level === "d";
								if(companyLogin && prop.name=="Dashboard"){
										return <li className={this.activeRoute(prop.path) + (prop.pro ? ' active active-pro' : '') + ' sidebar-item'} key={key}>
										<NavLink to={'/company-dashboard'} className="sidebar-link" activeClassName="active">
											<i className={prop.icon} />
											<span className="hide-menu">Dashboard</span>
										</NavLink>
									</li>}
								if(companyLogin && prop.name!="Dashboard"){
									return null;
								}
								else if (prop.navlabel) {
									return (
										<li className="nav-small-cap" key={key}>
											<i className={prop.icon}></i>
											<span className="hide-menu">{prop.name}</span>
										</li>
									);
								}
								else if (prop.collapse) {
									let firstdd = {};
									firstdd[prop["state"]] = !this.state[prop.state];
									return (
										/*--------------------------------------------------------------------------------*/
										/* Menus wiil be goes here                                                        */
										/*--------------------------------------------------------------------------------*/
										<li className={this.activeRoute(prop.path) + ' sidebar-item'} key={key}>
											<span data-toggle="collapse" className="sidebar-link has-arrow" aria-expanded={this.state[prop.state]} onClick={() => this.setState(firstdd)} >
												<i className={prop.icon} />&nbsp;&nbsp;
												<span className="hide-menu">{prop.name}</span>
											</span>
											{/*--------------------------------------------------------------------------------*/}
											{/* Sub-Menus wiil be goes here                                                    */}
											{/*--------------------------------------------------------------------------------*/}
											<Collapse isOpen={this.state[prop.state]}>
												<ul className="first-level">
													{prop.child.map((prop, key) => {
														if (prop.redirect) return null;
														if (prop.collapse) {
															let seconddd = {};
															seconddd[prop["state"]] = !this.state[prop.state];
															return (
																<li className={this.activeRoute(prop.path) + ' sidebar-item'} key={key} >
																	<span data-toggle="collapse" className="sidebar-link has-arrow" aria-expanded={this.state[prop.state]} onClick={() => this.setState(seconddd)} >
																		<i className={prop.icon} />
																		<span className="hide-menu">{prop.name}</span>
																	</span>
																	{/*--------------------------------------------------------------------------------*/}
																	{/* Sub-Menus wiil be goes here                                                    */}
																	{/*--------------------------------------------------------------------------------*/}
																	<Collapse isOpen={this.state[prop.state]}>
																		<ul className="second-level">
																			{prop.subchild.map((prop, key) => {
																				if (prop.redirect) return null;
																				return (
																					<li className={this.activeRoute(prop.path) + ' sidebar-item'} key={key} >
																						<NavLink to={prop.path} activeClassName="active" className="sidebar-link">
																							<i className={prop.icon} />
																							<span className="hide-menu">{prop.name}</span>
																						</NavLink>
																					</li>
																				);
																			})}
																		</ul>
																	</Collapse>
																</li>
															);
														}
														return (
															/*--------------------------------------------------------------------------------*/
															/* Adding Sidebar Item                                                            */
															/*--------------------------------------------------------------------------------*/
															<li className={this.activeRoute(prop.path) + (prop.pro ? ' active active-pro' : '') + ' sidebar-item'} key={key}>
																<NavLink to={prop.path} className="sidebar-link" activeClassName="active">
																	<i className={prop.icon} />
																	<span className="hide-menu">{prop.name}</span>
																</NavLink>
															</li>
														);
													})}
												</ul>
											</Collapse>
										</li>
									);
								}
								else {
									
										return (
											/*--------------------------------------------------------------------------------*/
											/* Adding Sidebar Item                                                            */
											/*--------------------------------------------------------------------------------*/
											<li className={this.activeRoute(prop.path) + (prop.pro ? ' active active-pro' : '') + ' sidebar-item'} key={key}>
												<NavLink to={prop.path} className="sidebar-link" activeClassName="active">
													<i className={prop.icon} />
													<span className="hide-menu">{prop.name}</span>
												</NavLink>
											</li>
										);
								}
							})}
							{/* A district manager gets the same, without District Manager and Account (src/utils/adminLevel.js) */}
							{(admin_level === 'c' || admin_level === 'd') && (
								<React.Fragment>
									{admin_level === 'c' && <li className={this.activeRoute('/district') + ' sidebar-item'}>
										<NavLink to={'/district'} className="sidebar-link" activeClassName="active">
											<i className="ti-map-alt" />
											<span className="hide-menu">Districts</span>
										</NavLink>
									</li>}
									{admin_level === 'c' && <li className={this.activeRoute('/district-manager') + ' sidebar-item'}>
										<NavLink to={'/district-manager'} className="sidebar-link" activeClassName="active">
											<i className="mdi mdi-account-settings" />
											<span className="hide-menu">District Manager</span>
										</NavLink>
									</li>}
									<li className={this.activeRoute('/supervisor') + ' sidebar-item'}>
										<NavLink to={'/supervisor'} className="sidebar-link" activeClassName="active">
											<i className="mdi mdi-account-alert" />
											<span className="hide-menu">Supervisors</span>
										</NavLink>
									</li>
									<li className={this.activeRoute('/clients') + ' sidebar-item'}>
										<NavLink to={'/clients'} className="sidebar-link" activeClassName="active">
											<i className="mdi mdi-account-multiple-outline" />
											<span className="hide-menu">Clients</span>
										</NavLink>
									</li>
									<li className={this.activeRoute('/guards') + ' sidebar-item'}>
										<NavLink to={'/guards'} className="sidebar-link" activeClassName="active">
											<i className="icon-shield" />
											<span className="hide-menu">Guards</span>
										</NavLink>
									</li>
									{admin_level === 'c' && <li className={this.activeRoute('/account') + ' sidebar-item allowed-while-suspended'}>
										<NavLink to={'/account'} className="sidebar-link" activeClassName="active">
											<i className="mdi mdi-account-cog" />
											<span className="hide-menu">Account</span>
										</NavLink>
									</li>}
								</React.Fragment>
							)}
							{(admin_level == 'a' || admin_level == 'b') && localStorage.getItem('companyId') && (
								<React.Fragment>
									<li className="nav-small-cap">
										<span className="hide-menu">{localStorage.getItem('companyName')}</span>
									</li>
									<li className={this.activeRoute('/district') + ' sidebar-item'}>
										<NavLink to={'/district'} className="sidebar-link" activeClassName="active">
											<i className="ti-map-alt" />
											<span className="hide-menu">Districts</span>
										</NavLink>
									</li>
									<li className={this.activeRoute('/district-manager') + ' sidebar-item'}>
										<NavLink to={'/district-manager'} className="sidebar-link" activeClassName="active">
											<i className="mdi mdi-account-settings" />
											<span className="hide-menu">District Manager</span>
										</NavLink>
									</li>
									<li className={this.activeRoute('/supervisor') + ' sidebar-item'}>
										<NavLink to={'/supervisor'} className="sidebar-link" activeClassName="active">
											<i className="mdi mdi-account-alert" />
											<span className="hide-menu">Supervisors</span>
										</NavLink>
									</li>
									<li className={this.activeRoute('/clients') + ' sidebar-item'}>
										<NavLink to={'/clients'} className="sidebar-link" activeClassName="active">
											<i className="mdi mdi-account-multiple-outline" />
											<span className="hide-menu">Clients</span>
										</NavLink>
									</li>
									<li className={this.activeRoute('/guards') + ' sidebar-item'}>
										<NavLink to={'/guards'} className="sidebar-link" activeClassName="active">
											<i className="icon-shield" />
											<span className="hide-menu">Guards</span>
										</NavLink>
									</li>
									<li className={this.activeRoute('/account') + ' sidebar-item allowed-while-suspended'}>
										<NavLink to={'/account'} className="sidebar-link" activeClassName="active">
											<i className="mdi mdi-account-cog" />
											<span className="hide-menu">Account</span>
										</NavLink>
									</li>
								</React.Fragment>
							)}
						</Nav>
					</PerfectScrollbar>
				</div>
			</aside>
		);
	}
}
export default connect(mapStateToProps)(Sidebar);
